/**
 * @file components/_common/constants 用到的常量
 * @author zhangzhe(zhangzhe@baidu.com)
 */

export const DU_PREFIX = 'du';

// TODO: 后期是否统一为acud-pro
export const ACUD_PRO_PREFIX = 'acud-pro';
